import React, { useEffect, useState } from 'react';
import {
  Typography,
  Input,
  InputNumber,
  DatePicker,
  Button,
  Icon,
  Table,
  Tag,
} from 'antd';
import style from './style.module.css';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import {
  REQUEST_DELETE_INCOME_EXPENSE_ENTRY,
  REQUEST_ADD_INCOME_EXPENSE_ENTRY,
  REQUEST_GET_INCOME_EXPENSE_BALANCE,
} from '../../Redux/constants/constants';
import formatToCurrency from '../../Utils/formatToCurrency';

const { Title } = Typography;
const { Column } = Table;

const IncomeAndExpense = ({ stageId }) => {
  const dispatch = useDispatch();
  const entries = useSelector((state) => state.incomeAndExpense);
  const balance = useSelector((state) => state.incomeAndExpenseBalance);
  const [localData, setLocalData] = useState({});

  useEffect(() => {
    dispatch({ type: REQUEST_GET_INCOME_EXPENSE_BALANCE, payload: stageId });
  }, []);

  const onChange = (e) => {
    setLocalData({ ...localData, [e.target.id]: e.target.value });
  };

  const onChangeDate = (date) => {
    const today = moment();
    setLocalData({
      ...localData,
      date: date ? date.format('YYYY-MM-DD') : today.format('YYYY-MM-DD'), // moment.js :( });
    });
  };

  const deleteEntry = ({ entryId, stageId }) => {
    dispatch({
      type: REQUEST_DELETE_INCOME_EXPENSE_ENTRY,
      payload: { entryId, stageId },
    });
  };

  const addIncome = () => {
    dispatch({
      type: REQUEST_ADD_INCOME_EXPENSE_ENTRY,
      payload: {
        stageId,
        value: localData.value,
        description: localData.description,
        date: localData.date,
        type: 'income',
      },
    });
    setLocalData({});
  };

  const addExpense = () => {
    dispatch({
      type: REQUEST_ADD_INCOME_EXPENSE_ENTRY,
      payload: {
        stageId,
        value: localData.value,
        description: localData.description,
        date: localData.date,
        type: 'expense',
      },
    });
    setLocalData({});
  };

  return (
    <>
      <Title level={4}>{`Przychód: ${formatToCurrency(balance)}`}</Title>
      <div className={style.inputContainer}>
        <Input
          className={style.amount}
          placeholder="amount"
          id="value"
          value={localData.value}
          onChange={(e) => onChange(e)}
        />
        <Input
          className={style.description}
          placeholder="description"
          id="description"
          value={localData.description}
          onChange={(e) => onChange(e)}
        />
        <DatePicker
          allowClear={false}
          className={style.date}
          id="date"
          value={localData.date ? moment(localData.date) : undefined}
          onChange={(date) => onChangeDate(date)}
        />
        <Button type="primary" className={style.buttonPlus} onClick={addIncome}>
          <Icon type="plus-circle" theme="filled" />
          Wpływy
        </Button>
        <Button
          type="danger"
          className={style.buttonMinus}
          onClick={addExpense}
        >
          <Icon type="minus-circle" theme="filled" />
          Wydatki
        </Button>
      </div>
      <Table
        rowKey={(record) => record.id}
        dataSource={entries}
        pagination={false}
        tableLayout="fixed"
      >
        <Column
          width="120px"
          title="Rodzaj"
          dataIndex="type"
          key="type"
          render={(type) => {
            const color = type === 'income' ? 'blue' : 'red';
            return (
              <span>
                <Tag color={color} key={type}>
                  {type}
                </Tag>
              </span>
            );
          }}
        />
        <Column
          width="120px"
          title="Kwota"
          dataIndex="value"
          key="value"
          render={(value) => {
            return <span>{formatToCurrency(value)}</span>;
          }}
        />
        <Column title="Tytuł" dataIndex="description" key="description" />
        <Column width="120px" title="Data" dataIndex="date" key="date" />
        <Column
          width="120px"
          title=" "
          key="name"
          render={(record) => (
            <a
              onClick={() => {
                deleteEntry({ entryId: record.id, stageId: record.stageId });
              }}
            >
              <Icon type="delete" theme="twoTone" />
              <span> Usuń</span>
            </a>
          )}
        />
      </Table>
    </>
  );
};

export default IncomeAndExpense;
